'use strict';

$ = jQuery;

/*
 * Evento de clique nos itens da barra de navegação das páginas por carroceria e estilo de vida
 */

$('#lp-content').on('click', '.jc-card-model a', function () {
  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Catálogo 0km',
    'eventAction': 'Clique - Card',
    'eventLabel': $(this).text()
  });

  gtag('event', 'Catálogo 0km', {
    'eventAction': 'Clique - Card',
    'eventLabel': $(this).text()
  });
});

/*
Evento de click nos itens da navbar
 */

$('#navbar-lps a').on('click', function () {

  var action = $(this).attr('data-nav-taxonomy') == 'estilos' ? 'Estilo de Vida' : $(this).attr('data-nav-taxonomy') == 'carrocerias' ? 'Carroceria' : 'Faixas de Preço';
  var label = $(this).attr('data-nav-item');

  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Catálogo 0km',
    'eventAction': 'Clique - Nav - ' + action,
    'eventLabel': '' + label
  });

  gtag('event', 'Catálogo 0km', {
    'eventAction': 'Clique - Nav - ' + action,
    'eventLabel': '' + label
  });
});